import script from "./OffersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OffersTable.vue?vue&type=script&setup=true&lang=js"

import "./OffersTable.vue?vue&type=style&index=0&id=3ff5eaae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff5eaae"]])

export default __exports__